module.exports = __webpack_public_path__ + "img/htcm_07.b5a05c84.jpg";